import { createTheme, Stack, Typography } from '@mui/material';
import { StyledBadge } from './StyledBadge';
import { serverStatusEnum } from './enums/serverStatusEnum';

export default function ServerStatusView({ serverStatus }) {
  const theme = createTheme();
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={2}
      sx={{
        zIndex: '10000', // Certifique-se que está acima de outros componentes
        position: 'fixed',
        bottom: 10, // Ou 'top: 10' se quiser no topo
        left: 10, // Ajuste conforme necessário
        backgroundColor: theme.palette.divider, // Evita sobreposição com transparência
        padding: 2,
        borderRadius: 2,
        boxShadow: 3, // Dá um destaque visual
      }}
    >
      <StyledBadge
        statusColor={serverStatusEnum[serverStatus.name].color}
        overlap="circular"
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        variant="dot"
      />
      <Typography>{serverStatus.message}</Typography>
    </Stack>
  );
}
